// Analytics tracking hook for SEO landing pages
import { useEffect, useCallback } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

// Track page view
export const trackPageView = async (path) => {
  try {
    await fetch(`${API_URL}/api/analytics/pageview`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        path: path,
        referrer: document.referrer || null,
        user_agent: navigator.userAgent || null
      })
    });
  } catch (error) {
    console.error('Failed to track pageview:', error);
  }
};

// Track conversion (CTA clicks, form submits, etc.)
export const trackConversion = async (path, conversionType = 'contact_click') => {
  try {
    await fetch(`${API_URL}/api/analytics/conversion`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        path: path,
        conversion_type: conversionType
      })
    });
  } catch (error) {
    console.error('Failed to track conversion:', error);
  }
};

// Hook for automatic page view tracking
export const usePageTracking = (path) => {
  useEffect(() => {
    if (path) {
      trackPageView(path);
    }
  }, [path]);
  
  const trackClick = useCallback((conversionType = 'contact_click') => {
    if (path) {
      trackConversion(path, conversionType);
    }
  }, [path]);
  
  return { trackClick };
};

// Fetch analytics stats for admin dashboard
export const fetchAnalyticsStats = async () => {
  try {
    const response = await fetch(`${API_URL}/api/analytics/stats`);
    if (response.ok) {
      return await response.json();
    }
    return null;
  } catch (error) {
    console.error('Failed to fetch analytics:', error);
    return null;
  }
};

export default { trackPageView, trackConversion, usePageTracking, fetchAnalyticsStats };
